import type { HeroComponentProps } from '../../../components/HeroComponent/HeroComponent';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
const transformHeroComponent = (data: CMSTransformerDataType): HeroComponentProps => {
  const heroComponent = Array.isArray(data.hero_component) ? data.hero_component[0] : data.hero_component;
  return {
    componentType: ComponentType.hero_component,
    heroDescription: heroComponent.sub_title,
    heroTitle: heroComponent.display_title,
    images: heroComponent.image.images,
    tagline: heroComponent.tagline,
    ctaButton: heroComponent.link,
  };
};

export default transformHeroComponent;
